import { useAppSetting } from '@ztechapps/common.hook'
import type { IOption, ISpecification } from '@ztechapps/common.contract'
import { jsonTryParse } from '@ztechapps/common.utils'
import get from 'lodash/get'

export const useProductSpecification = <T>(name: string): T => {
  //look for the appSetting with the key of PRODUCT_SPECIFICATIONS
  const appSetting = useAppSetting({ appSettingKey: 'PRODUCT_SPECIFICATIONS' })

  const stringValue = appSetting.setting?.value

  //parse it to hte actual object
  const parsedValue = jsonTryParse(stringValue) as Record<any, any>

  const specValue = get(parsedValue, name)

  return specValue
}

const useProductSpecificationOptions = (name: string): IOption[] => {
  const spec = useProductSpecification<ISpecification>(name)
  const result = spec?.inputProps?.options
  return result
}

export const useDieSetTypes = (): IOption[] => {
  return useProductSpecificationOptions('dieSetType')
}
export const useDieShapes = (): IOption[] => {
  return useProductSpecificationOptions('shape')
}
export const useProductCategories = (): IOption[] => {
  return useProductSpecificationOptions('category')
}
